import React from "react";
import { motion } from "framer-motion";
import {
  FaGithub,
  FaLinkedin,
  FaTelegramPlane,
  FaInstagram,
} from "react-icons/fa";
import profile from "./../../assets/bossf.png";
import "./Hero.css";

const Hero = () => {
  const handleDownload = () => {
    const cvFilePath = "/cv/firaol-Tegene resume.pdf";
    const a = document.createElement("a");
    a.href = cvFilePath;
    a.download = "Firaol-Tegene-Resume.pdf";
    a.click();
  };

  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center px-6 md:px-14 pt-36"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center w-full">
        {/* LEFT CONTENT */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex flex-col gap-6"
        >
          <h1 className="text-4xl md:text-6xl font-bold leading-tight">
            Hi, I&apos;m <span className="gradient-text">Firaol Tegene</span>
          </h1>

          <p className="text-lg md:text-xl text-gray-400 leading-relaxed max-w-xl">
            I'm motivated Full-Stack Developer with a keen focus and experience
            in web application development and web layout design, with a strong
            work ethic and innate ability to adapt in ever-changing and
            challenging environments.
          </p>

          {/* ACTION BUTTONS */}
          <div className="flex gap-4 mt-4">
            <a href="#contact">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="px-6 py-3 rounded-xl gradient-bg text-white font-semibold"
              >
                Contact Me →
              </motion.button>
            </a>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleDownload}
              className="px-6 py-3 rounded-xl border border-gray-500 text-white hover:bg-white hover:text-black transition"
            >
              Download CV
            </motion.button>
          </div>

          {/* SOCIAL LINKS */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex gap-4 mt-6"
          >
            <SocialIcon href="https://github.com/firaol-tag">
              <FaGithub />
            </SocialIcon>
            <SocialIcon href="https://www.linkedin.com/in/firaol-tegene-a8461a232">
              <FaLinkedin />
            </SocialIcon>
            <SocialIcon href="https://t.me/fira_ftf">
              <FaTelegramPlane />
            </SocialIcon>
            <SocialIcon href="https://www.instagram.com/firaoltegeneftf?igsh=eXh1YjJxZGxjOGt0">
              <FaInstagram />
            </SocialIcon>
          </motion.div>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex justify-center"
        >
          <img
            src={profile}
            alt="Firaol Tegene"
            className="w-64 md:w-80 lg:w-[420px] rounded-2xl object-cover shadow-2xl"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;

/* Reusable social icon */
const SocialIcon = ({ href, children }) => (
  <motion.a
    href={href}
    target="_blank"
    rel="noreferrer"
    whileHover={{ y: -5, scale: 1.1 }}
    className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 text-white text-xl backdrop-blur-md hover:bg-white hover:text-black transition"
  >
    {children}
  </motion.a>
);
